export default __webpack_public_path__ + "static/media/acessibilidade-moon.e5585e50.png";